import React, { memo } from 'react';
import cn from 'classnames';

interface SROnlyProps {
  children?: React.ReactNode;
  className?: string;
  component?: keyof JSX.IntrinsicElements;

  [key: string]: unknown;
}

const SROnly = ({
  children,
  className,
  component = 'span',
  ...props
}: SROnlyProps) => {
  const Tag = component as React.ElementType;

  return (
    <Tag
      className={cn('sr-only', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Tag>
  );
};

export default memo(SROnly);
